<template>
  <div class="filter">
    <el-select
      v-model="value"
      :multiple="allowMultiple"
      collapse-tags
      :filterable="searchable"
      @change="filter"
      :clearable="clearable"
      :data-qa="dataQa"
    >
      <el-option
        v-for="index in optionsOrder"
        :key="index"
        :value="index"
        :label="options[index]"
      />
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'RestListFilterSelect',

  inject: ['restList'],

  props: {
    prop: {
      type: String,
      required: false
    },

    options: {
      required: true
    },

    order: {
      required: false
    },

    allowMultiple: {
      type: Boolean,
      default: false
    },

    clearable: {
      type: Boolean,
      default: true
    },

    defaultValue: {
      required: false
    },

    dataQa: {
      type: String,
      required: false
    },

    searchable: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      value: null
    }
  },

  mounted() {
    if (this.defaultValue) {
      this.value = this.allowMultiple
        ? this.defaultValue.split(',')
        : this.defaultValue
      this.filter()
    }
  },

  computed: {
    optionsOrder() {
      if (this.order) {
        return this.order
      } else {
        return Object.keys(this.options)
      }
    }
  },

  methods: {
    filter() {
      this.restList.filterField(
        this.prop,
        this.allowMultiple ? this.value.join(',') : this.value
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/common/components/rest/RestListFilterSelect.vue